import script from "./Tasks.vue?vue&type=script&setup=true&lang=js"
export * from "./Tasks.vue?vue&type=script&setup=true&lang=js"

import "./Tasks.vue?vue&type=style&index=0&id=f0ead402&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0ead402"]])

export default __exports__